export default "__VITE_ASSET__D9fyHrnx__"